import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import {
  createMassPayUserBuilder,
  deleteWithdrawalMethodBuilder,
  fetchMassPayActivationUrlBuilder,
  fetchMassPayCountriesBuilder,
  fetchWithdrawalsBuilder,
  requestWithdrawalBuilder,
} from './builder';

const INIT_STATE = {
  fetchWithdrawalsInfo: {
    pending: false,
    data: [],
    total: 0,
  },
  pending: {
    requestWithdrawal: false,
    deleteWithdrawalMethod: false,
    fetchMassPayActivationUrl: false,
    createMassPayUser: false,
  },
  massPayCountries: [],
};

export const withdrawalSlice = createSlice({
  name: 'withdrawal',
  initialState: INIT_STATE,
  reducers: {},
  extraReducers: builder => {
    fetchWithdrawalsBuilder(builder);
    requestWithdrawalBuilder(builder);
    deleteWithdrawalMethodBuilder(builder);
    createMassPayUserBuilder(builder);
    fetchMassPayActivationUrlBuilder(builder);
    fetchMassPayCountriesBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const selectWithdrawalActionsPending = state => state.withdrawalInfo.pending;
export const selectFetchWithdrawalsInfo = state => state.withdrawalInfo.fetchWithdrawalsInfo;
export const selectMassPayCountries = state => state.withdrawalInfo.massPayCountries;

export default withdrawalSlice.reducer;
